<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules" size="mini">
      <el-row :gutter="10" class="head_text">
        <el-col :span="12">
          <div>
            {{ $l('form_original_customer_information') || '原客户基本信息' }}
          </div>
        </el-col>
        <el-col :span="12">
          <div>
            {{
              $l('form_customer_information_after_change') ||
              '变更后客户基本信息'
            }}
          </div>
        </el-col>
        <el-col :span="24">
          <el-divider></el-divider>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$l('form_label_custName') || '客户公司名称'">
            <el-input v-model="oldForm.custNameOld" readonly :flag="'flag'" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_custName') || '客户公司名称'"
            prop="custName"
          >
            <el-input
              v-model="formData.custName"
              :placeholder="
                $l('form_placeholder_custName') || '请输入客户公司名称'
              "
              maxlength="200"
              clearable
              @change="valueChange"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_businessLicense') || '客户公司税号'"
          >
            <el-input
              v-model="oldForm.businessLicenseOld"
              readonly
              :flag="'flag'"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_businessLicense') || '客户公司税号'"
            prop="businessLicense"
          >
            <el-input
              v-model="formData.businessLicense"
              :placeholder="
                $l('form_placeholder_businessLicense') || '请输入客户公司税号'
              "
              maxlength="50"
              clearable
              @change="valueChange"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$l('form_label_custAddress') || '客户经营地址'">
            <el-input
              v-model="oldForm.custAddressOld"
              readonly
              :flag="'flag'"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_custAddress') || '客户经营地址'"
            prop="custAddress"
          >
            <el-input
              v-model="formData.custAddress"
              :placeholder="
                $l('form_placeholder_custAddress') || '请输入客户经营地址'
              "
              maxlength="500"
              clearable
              @change="valueChange"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item :label="$l('form_label_region') || '所在国家'">
                <el-input
                  v-model="oldForm.regionNameOld"
                  readonly
                  :flag="'flag'"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_contactMobile') || '客户联系电话'"
              >
                <el-input
                  v-model="oldForm.contactMobileOld"
                  readonly
                  :flag="'flag'"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="12">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_region') || '所在国家'"
                prop="regionCode"
              >
                <dict-select
                  v-model="formData.regionCode"
                  :selectedLabel.sync="formData.regionName"
                  :placeholder="
                    $l('form_placeholder_region') || '请选择所在国家'
                  "
                  url="/master/common/dict/biz"
                  :body="{ dictType: 'region' }"
                  size="mini"
                  clearable
                  filterable
                  @change="valueChange"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_contactMobile') || '客户联系电话'"
                prop="contactMobile"
              >
                <el-input
                  v-model="formData.contactMobile"
                  :placeholder="
                    $l('form_placeholder_contactMobile') || '请输入客户联系电话'
                  "
                  clearable
                  @change="valueChange"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <el-row :gutter="10" class="head_text mt-4">
        <el-col :span="12">
          <div>
            {{
              $l('form_original_business_setting_information') ||
              '原业务设置信息'
            }}
          </div>
        </el-col>
        <el-col :span="12">
          <div>
            {{
              $l('form_business_setting_information_after_change') ||
              '变更后业务设置信息'
            }}
          </div>
        </el-col>
        <el-col :span="24">
          <el-divider></el-divider>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_custShortName') || '客户简称'"
              >
                <el-input
                  v-model="oldForm.custShortNameOld"
                  readonly
                  :flag="'flag'"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_customerBizType') || '客户类型'"
              >
                <el-input
                  v-model="oldForm.v_customerBizTypeOld"
                  readonly
                  :flag="'flag'"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_customerType') || '客户性质'"
              >
                <el-input
                  v-model="oldForm.v_customerTypeOld"
                  readonly
                  :flag="'flag'"
                />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item :label="$l('form_label_sales') || '接待人员'">
                <el-input
                  v-model="oldForm.salesNameOld"
                  readonly
                  :flag="'flag'"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_riskAssessor') || '财务风险评估人'"
              >
                <el-input
                  v-model="oldForm.riskAssessorNameOld"
                  readonly
                  :flag="'flag'"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_dep') || '业务部门'">
                <el-input
                  v-model="oldForm.orgDepFullNameOld"
                  readonly
                  :flag="'flag'"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$l('form_label_managerApproval') || '部门主管审批人'">
                <el-input
                  v-model="oldForm.managerApprovalByNameOld"
                  readonly
                  :flag="'flag'"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$l('form_label_approver') || '审批负责人'">
                <el-input
                  v-model="oldForm.approverNameOld"
                  readonly
                  :flag="'flag'"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="12">
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_custShortName') || '客户简称'"
                prop="custShortName"
              >
                <el-input
                  v-model="formData.custShortName"
                  :placeholder="
                    $l('form_placeholder_custShortName') || '请输入客户简称'
                  "
                  maxlength="200"
                  clearable
                  @change="valueChange"
                />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_customerBizType') || '客户类型'"
                prop="customerBizType"
              >
                <dict-select
                  v-model="formData.customerBizType"
                  :selectedLabel.sync="formData.v_customerBizType"
                  :placeholder="
                    $l('form_placeholder_customerBizType') || '请选择客户类型'
                  "
                  url="/digitalCenter/common/dict/system"
                  :body="{ dictType: 'customerBizType' }"
                  clearable
                  @change="valueChange"
                  filterable
                  size="mini"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_customerType') || '客户性质'"
                prop="customerType"
              >
                <dict-select
                  v-model="formData.customerType"
                  :selectedLabel.sync="formData.v_customerType"
                  :placeholder="
                    $l('form_placeholder_customerType') || '请选择客户性质'
                  "
                  url="/digitalCenter/common/dict/biz"
                  :body="{ dictType: 'customerType' }"
                  clearable
                  filterable
                  size="mini"
                  @change="valueChange"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_sales') || '接待人员'"
                prop="salesCode"
              >
                <dict-select
                  v-model="formData.salesCode"
                  :selectedLabel.sync="formData.salesName"
                  :placeholder="
                    $l('form_placeholder_sales') || '请选择接待人员'
                  "
                  url="/master/common/dict/baseUserSelect"
                  clearable
                  filterable
                  size="mini"
                  @change="salesChange"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_riskAssessor') || '财务风险评估人'"
                prop="riskAssessorCode"
              >
                <dict-select
                  v-model="formData.riskAssessorCode"
                  :selectedLabel.sync="formData.riskAssessorName"
                  :placeholder="
                    $l('form_placeholder_riskAssessor') ||
                    '请选择财务风险评估人'
                  "
                  url="/master/common/dict/baseUserSelect"
                  clearable
                  filterable
                  size="mini"
                  @change="valueChange"
                />
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_dep') || '业务部门'"
                prop="depCode"
              >
                <dep-cascader
                  :lastValue.sync="formData.depCode"
                  :pathLabels.sync="formData.orgDepFullName"
                  :placeholder="$l('form_placeholder_dep') || '请选择业务部门'"
                  size="mini"
                  @change="valueChange"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$l('form_label_managerApproval') || '部门主管审批人'" prop="managerApprovalBy">
                <dict-select
                  v-model="formData.managerApprovalBy"
                  :selectedLabel.sync="formData.managerApprovalByName"
                  :placeholder="this.$l('form_placeholder_managerApproval') ||'请选择部门主管审批人'"
                  url="/master/common/dict/baseUserSelect"
                  clearable
                  filterable
                  size="mini"
                  @change="valueChange"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_approver') || '审批负责人'"
                prop="approverCode"
              >
                <dict-select
                  v-model="formData.approverCode"
                  :selectedLabel.sync="formData.approverName"
                  :placeholder="
                    $l('form_placeholder_approver') || '请选择审批负责人'
                  "
                  url="/master/common/dict/baseUserSelect"
                  clearable
                  filterable
                  size="mini"
                  @change="valueChange"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <div class="mt-3 mb-1">
            <h6>
              <span class="text-danger">*</span>
              <span style="color: #101010">
                {{
                  $l('form_label_reason_change_explanation') || '变更原因说明'
                }}
              </span>
            </h6>
            <p
              style="font-size: 14px; color: #6c6c6c"
              class="m-0 text-truncate"
            >
              {{
                $l('form_ple_fill_in_explanation_for_change') ||
                '请填写本次变更信息的情况说明'
              }}
            </p>
          </div>
          <el-form-item prop="remark">
            <div>
              <el-input
                v-model="formData.remark"
                type="textarea"
                :rows="6"
                :maxlength="500"
                show-word-limit
                clearable
                @change="valueChange"
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('dialog_want_to_submit_changes') || '是否要提交变更' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('btn_not_submit_changes') || '不提交变更' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('btn_submit_changes') || '提交变更' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: {},
  props: {
    custCode: { type: String, default: '' },
  },
  data() {
    return {
      backDialogVisible: false,
      valueChangeFlag: false,
      formData: {},
      oldForm: {},
      rules: {
        custName: [
          {
            required: true,
            message:
              this.$l('form_placeholder_custName') || '请输入客户公司名称',
            trigger: 'blur',
          },
        ],
        businessLicense: [
          {
            required: true,
            message:
              this.$l('form_placeholder_businessLicense') ||
              '请输入客户公司税号',
            trigger: 'blur',
          },
        ],
        regionCode: [
          {
            required: true,
            message: this.$l('form_placeholder_region') || '请选择所在国家',
            trigger: 'change',
          },
        ],
        custAddress: [
          {
            required: true,
            message:
              this.$l('form_placeholder_custAddress') || '请输入客户经营地址',
            trigger: 'blur',
          },
        ],
        contactMobile: [
          {
            required: true,
            message:
              this.$l('form_placeholder_contactMobile') || '请输入客户联系电话',
            trigger: 'blur',
          },
        ],
        custShortName: [
          {
            required: true,
            message:
              this.$l('form_placeholder_custShortName') || '请输入客户简称',
            trigger: 'blur',
          },
        ],
        customerBizType: [
          {
            required: true,
            message:
              this.$l('form_placeholder_customerBizType') || '请选择客户类型',
            trigger: 'change',
          },
        ],
        customerType: [
          {
            required: true,
            message:
              this.$l('form_placeholder_customerType') || '请选择客户性质',
            trigger: 'change',
          },
        ],
        riskAssessorCode: [
          {
            required: true,
            message:
              this.$l('form_placeholder_riskAssessor') ||
              '请选择财务风险评估人',
            trigger: 'change',
          },
        ],
        salesCode: [
          {
            required: true,
            message: this.$l('form_placeholder_sales') || '请选择接待人员',
            trigger: 'change',
          },
        ],
        depCode: [
          {
            required: true,
            message: this.$l('form_placeholder_dep') || '请选择业务部门',
            trigger: 'change',
          },
        ],
        approverCode: [
          {
            required: true,
            message: this.$l('form_placeholder_approver') || '请选择审批负责人',
            trigger: 'change',
          },
        ],
        managerApprovalBy: [
          {
            required: true,
            message: this.$l('form_placeholder_managerApproval') ||'请选择部门主管审批人',
            trigger: 'change',
          },
        ],
        remark: [
          {
            required: true,
            message: this.$l('form_placeholder_reason') || '请输入变更原因说明',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {},
  mounted() {
    this.getData()
  },
  methods: {
    valueChange() {
      this.valueChangeFlag = true
    },
    async getData() {
      if (!this.custCode) return
      this.loading = true
      const res = await this.$api
        .masterCustomerV2DetailApi({ custCode: this.custCode })
        .catch(() => {})
      this.loading = false
      const data = res.body || {}
      this.formData = { ...data }
      for (const key in this.formData) {
        const newKey = key + 'Old'
        this.oldForm[newKey] = this.formData[key]
      }
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      let param = {}
      for (const key in this.formData) {
        if (key == 'remark') continue
        const newKey = key + 'Old'
        if (this.oldForm[newKey] != this.formData[key]) {
          param[key] = this.formData[key]
        }
      }
      if (!param || Object.keys(param).length === 0) {
        this.$message.warning(
          this.$l('tip_information_not_change') ||
            '信息未变更，请修改后重新提交变更！'
        )
        return (this.backDialogVisible = false)
      }
      param.remark = this.formData.remark
      if (this.loadingOpen()) return
      const res = await this.$api
        .masterCustomerInfoChangeApi({
          updateContent: JSON.stringify(param),
          custCode: this.formData.custCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_submission_failed') || '提交失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('tips_Submitted_successfully') || '提交成功！',
        type: 'success',
      })
      this.close()
      this.$emit('reload')
      return true
    },
    async salesChange(userCode) {
      this.valueChangeFlag = true
      const getUser = async () => {
        if (!userCode) return {}
        const res = await this.$api
          .sysUserDetailApi({ userCode })
          .catch(() => null)
        return res?.body || {}
      }

      const userInfo = await getUser()
      const { depCode, orgDepFullName } = userInfo
      this.formData.depCode = depCode
      this.formData.orgDepFullName = orgDepFullName
    },
    cancel() {
      if (!this.valueChangeFlag) return this.close()
      this.backDialogVisible = true
    },
    close() {
      this.valueChangeFlag = false
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-card {
    border: none;
  }
  .el-card__body {
    padding: 16px;
  }
  .el-divider--horizontal {
    margin: 12px 0;
  }

  .el-input .el-input__inner[flag='flag'] {
    background-color: #f9f9f9;
    border: none !important;
  }
}
.head_text {
  color: #101010;
  font-size: 16px;
  font-weight: 600;
}
</style>
